import React, { useId } from "react";

export type TooltipProps = {
  children: React.ReactNode
  className?: string
  title: React.ReactNode
  triggerLabel?: string
}

export default function Tooltip({
  children,
  className,
  title,
  triggerLabel = "Show details",
}: TooltipProps) {
  const tooltipId = useId()

  return (
    <span className={["tooltip", className].filter(Boolean).join(" ")}>
      <button
        type="button"
        className="tooltip__trigger"
        aria-describedby={tooltipId}
        aria-label={triggerLabel}
      >
        {children}
      </button>
      <span
        id={tooltipId}
        role="tooltip"
        className="tooltip__content"
      >
        {title}
      </span>
    </span>
  )
}
